import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var generateStyle = function generateStyle(componentTheme, props) {
  var containerVariant = {
    row: {
      margin: "0 calc(-1 * ".concat(componentTheme.seriesContainerRowMargin, ")"),
      '.seriesContainer': {
        display: 'inline-flex',
        padding: "0 ".concat(componentTheme.seriesContainerRowMargin)
      }
    },
    column: {
      border: "".concat(componentTheme.containerBorderWidth, " solid ").concat(componentTheme.containerBorderColor),
      '.seriesContainer': {
        display: 'flex'
      }
    }
  };
  return {
    seriesContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      margin: componentTheme.seriesContainerMargin
    },
    containerStyle: _objectSpread({}, containerVariant[props.variant]),
    seriesSwatchContainer: {
      width: '1.2rem',
      height: '1.2rem',
      marginRight: componentTheme.seriesSwatchMargin,
      display: 'flex'
    },
    seriesSwatch: {
      flex: 1
    },
    seriesLabel: {
      fontFamily: componentTheme.seriesLabelFontFamily,
      fontSize: componentTheme.seriesLabelFontSize,
      whiteSpace: 'nowrap',
      color: componentTheme.seriesLabelColor
    }
  };
};
export default generateStyle;